module.exports = __webpack_public_path__ + "static/bg-sec11-sm-7220260e18914d66ae4dc432d2fada85.jpg";